module.exports = __webpack_public_path__ + "img/categorie-nos-points-de-vente-famille-boutrais-medium.aa8c2a6e.jpg";